<template>
    <v-card-title
        class="pt-1 pb-1 headline grey lighten-2"
        color="primary"
        primary-title
    >
        <span class="headline">{{ dialogName }}</span>
        <v-spacer />
        <v-btn
            @click.stop="close()"
            fab
            rounded
            small
            text
        >
            X
        </v-btn>
    </v-card-title>
</template>

<script>

    export default {
        name: "EditDialogTitle",

        props: {
            dialogName: {
                default: '',
                type: String
            },
            close: {
                default: undefined,
                type: Function
            }
        }
    }
</script>

<style scoped>

</style>
